export default __webpack_public_path__ + "static/media/Chat2.c1269223.svg";